/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Icon_ChooseInputs */



/**
* | output |
* | --- |
* | "Choose an icon" |
*
* @param {Personas_Icon_ChooseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_icon_choose = /** @type {((inputs?: Personas_Icon_ChooseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Icon_ChooseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Symbol auswählen")
	return /** @type {LocalizedString} */ ("Choose an icon")
});